module.exports = __webpack_public_path__ + "static/media/cover.c2399b95.jpg";